import { useParams } from 'react-router-dom';

export const useExpenseId = () => useParams<Dictionary<string>>().id!;
